// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"189":"be0565ed","197":"5bb91124","351":"7a2e7ca2","580":"63666df4"}[chunkId] + ".css";
};